export const LANGUAGES = [
  {
    name: 'Afar',
    id: 1
  },
  {
    name: 'Afrikaans',
    id: 2
  },
  {
    name: 'Akan',
    id: 3
  },
  {
    name: 'Albanian',
    id: 4
  },
  {
    name: 'American Sign Language',
    id: 5
  }, 
  {
    name: 'Amharic',
    id: 6
  }, 
  {
    name: 'Another Language',
    id: 7
  }, 
  {
    name: 'Arabic',
    id: 8
  },
  {
    name: 'Armenian',
    id: 9
  },
  {
    name: 'Azerbaijani',
    id: 10
  }, 
  {
    name: 'Bengali',
    id: 11
  },
  {
    name: 'Bosnian',
    id: 12
  },
  {
    name: 'Bulgarian',
    id: 13
  },
  {
    name: 'Burmese',
    id: 14
  },
  {
    name: 'Cambodian',
    id: 15
  },
  {
    name: 'Cape Verdean',
    id: 16
  },
  {
    name: 'Cape Verdean Creole',
    id: 17
  },
  {
    name: 'Catalan',
    id: 18
  }, 
  {
    name: 'Chinese',
    id: 19
  }, 
  {
    name: 'Chinese Cantonese',
    id: 20
  },
  {
    name: 'Chinese Mandarin',
    id: 21
  },
  {
    name: 'Chinese Other',
    id: 22
  },
  {
    name: 'Chinese Toisanese',
    id: 23
  },
  {
    name: 'Choose not to answer',
    id: 24
  },
  {
    name: 'Comm Access Real Time Trans',
    id: 25
  },
  {
    name: 'Croatian',
    id: 26
  },
  {
    name: 'Czech',
    id: 27
  },
  {
    name: 'Danish',
    id: 28
  },
  {
    name: 'Dari',
    id: 29
  },
  {
    name: 'Declined to Answer',
    id: 30
  },
  {
    name: "Don't know",
    id: 31
  },
  {
    name: 'Dutch',
    id: 32
  },
  {
    name: 'English',
    id: 33
  },
  {
    name: 'Ethiopian',
    id: 34
  },
  {
    name: 'Farsi',
    id: 35
  },
  {
    name: 'Finnish',
    id: 36
  },
  {
    name: 'French',
    id: 37
  },
  {
    name: 'Fulah',
    id: 38
  },
  {
    name: 'Fuzhou',
    id: 39
  },
  {
    name: 'Georgian',
    id: 40
  },
  {
    name: 'German',
    id: 41
  },
  {
    name: 'Greek',
    id: 42
  },
  {
    name: 'Gujarati',
    id: 43
  },
  {
    name: 'Haitian',
    id: 44
  },
  {
    name: 'Haitian Creole',
    id: 45
  },
  {
    name: 'Hakka Chin',
    id: 46
  },
  {
    name: 'Hausa',
    id: 47
  },
  {
    name: 'Hebrew',
    id: 48
  },
  {
    name: 'Hindi',
    id: 49
  },
  {
    name: 'Hmong',
    id: 50
  },
  {
    name: 'Hungarian',
    id: 51
  },
  {
    name: 'Icelandic',
    id: 52
  },
  {
    name: 'Igbo',
    id: 53
  },
  {
    name: 'Indonesian',
    id: 54
  },
  {
    name: 'Irish',
    id: 55
  },
  {
    name: 'Italian',
    id: 56
  },
  {
    name: 'Japanese',
    id: 57
  },
  {
    name: 'Kannada',
    id: 58
  },
  {
    name: 'Karen',
    id: 59
  },
  {
    name: 'Kazakh',
    id: 60
  },
  {
    name: 'Kiche',
    id: 61
  },
  {
    name: 'Kinyarwanda',
    id: 62
  },
  {
    name: 'Khmer',
    id: 63
  },
  {
    name: 'Korean',
    id: 64
  },
  {
    name: 'Kurdish',
    id: 65
  },
  {
    name: 'Latvian',
    id: 66
  },
  {
    name: 'Laotian',
    id: 67
  },
  {
    name: 'Lingala',
    id: 68
  },
  {
    name: 'Lithuanian',
    id: 69
  },
  {
    name: 'Malay',
    id: 70
  },
  {
    name: 'Marathi',
    id: 71
  },
  {
    name: 'Mongolian',
    id: 72
  },
  {
    name: 'Moroccan Arabic',
    id: 73
  },
  {
    name: 'Nepali',
    id: 74
  },
  {
    name: 'Norwegian',
    id: 75
  },
  {
    name: 'Oromo',
    id: 76
  },
  {
    name: 'Other Language',
    id: 77
  },
  {
    name: 'Pashto',
    id: 78
  },
  {
    name: 'Polish',
    id: 79
  },
  {
    name: 'Portuguese',
    id: 80
  },
  {
    name: 'Punjabi',
    id: 81
  },
  {
    name: 'Quechua',
    id: 82
  },
  {
    name: 'Romanian',
    id: 83
  },
  {
    name: 'Rundi',
    id: 84
  },
  {
    name: 'Russian',
    id: 85
  },
  {
    name: 'Serbian',
    id: 86
  },
  {
    name: 'Shona',
    id: 87
  },
  {
    name: 'Sign Lang Plus Blind',
    id: 88
  },
  {
    name: 'Sign Lang Plus CDI',
    id: 89
  },
  {
    name: 'Sign Lang Plus CDI Plus Blind',
    id: 90
  },
  {
    name: 'Sign Language',
    id: 91
  },
  {
    name: 'Serbo-Croatian',
    id: 92
  },
  {
    name: 'Slovak',
    id: 93
  },
  {
    name: 'Slovenian',
    id: 94
  },
  {
    name: 'Somali',
    id: 95
  },
  {
    name: 'Somalian',
    id: 96
  },
  {
    name: 'Spanish',
    id: 97
  },
  {
    name: 'Swahili',
    id: 98
  },
  {
    name: 'Swedish',
    id: 99
  },
  {
    name: 'Tagalog',
    id: 100
  },
  {
    name: 'Taiwanese/Fukienese',
    id: 101
  },
  {
    name: 'Tamil',
    id:102
  },
  {
    name: 'Telugu',
    id: 103
  },
  {
    name: 'Thai',
    id: 104
  },
  {
    name: 'Tibetan',
    id: 105
  },
  {
    name: 'Tigrinya',
    id: 106
  },
  {
    name: 'Toisanese',
    id: 107
  },
  {
    name: 'Turkish',
    id: 108
  },
  {
    name: 'Twi',
    id: 109
  },
  {
    name: 'Ukrainian',
    id: 110
  },
  {
    name: 'Unable to Collect',
    id: 111
  },
  {
    name: 'Urdu',
    id: 112
  },
  {
    name: 'Uyghur',
    id: 113
  },
  {
    name: 'Uzbek',
    id: 114
  },
  {
    name: 'Vietnamese',
    id: 115
  },
  {
    name: 'Yiddish',
    id: 116
  },
  {
    name: 'Yoruba',
    id: 117
  },
  {
    name: 'Zulu',
    id: 118
  },
];
// use comma separated string as input, return array of id
export const getIds = (langs) => {
  let Ids = Array.prototype.map.call(langs.split(','), function (x) {
    var langId = LANGUAGES.find((obj) => {
      return obj.name === x;
    }).id;
    return langId;
  });
  console.log('language:getIds - language ids: ', Ids);
  return Ids;
};

// use comma separated string as input, return array of id
export const getLangsFromString = (langs) => {
  let langsArray = Array.prototype.map.call(langs.split(','), function (x) {
    var lang = LANGUAGES.find((obj) => {
      return obj.name === x;
    });
    return lang;
  });
  console.log('language:getLangsFromString - language objs: ', langsArray);
  return langsArray;
};

export const getNames = (ids) => {
  if (ids === undefined) return '';
  let langs = Array.prototype.map
    .call(ids, function (x) {
      var lang = LANGUAGES.find((obj) => {
        return obj.id === x.id;
      });
      return lang !== undefined ? lang.name : '';
    })
    .join();
  console.log('language:getNames - language: ', langs);
  return langs;
};

